class Workflow {

    constructor(tasks) {
        this.tasks = tasks; //任务列表
        this.context = []; //参数上下文
        this.finished = false;//运行状态
    }

    createWorkflow() {

        var that = this;
        var context = that.context;
        return function* workflow() {
            var tasks = that.tasks;
            for (let i = 0; i < tasks.length; i++) {
                var time = tasks[i].delay;
                yield delayRun(time); // 

                var fun = tasks[i].fun; //Promise
                var params = tasks[i].params;
                yield fun(params, context);
            }
        }

        function delayRun(ms) {
            return new Promise((resolve) => setTimeout(() => {
                resolve();
            }, ms));
        }

    }


    runWorkflow() {
        const workflow = this.createWorkflow();
        const iterator = workflow();
        var that = this;
        var context = that.context;

        function handleNextIteration(result) {
            if (result.done) {
                console.log("Workflow finished.");
                that.endTime = new Date();  // 当前时间
                that.finished = true;
                return;
            }

            const promise = Promise.resolve(result.value);
            context.push(result.value);

            promise.then(() => {
                handleNextIteration(iterator.next());
            });
        }

        this.startTime = new Date();  // 当前时间
        handleNextIteration(iterator.next());
    }

    getTimestampDiff() {
        // 将时间字符串转换为Date对象
        var start = this.startTime;
        var end = this.finished ? this.endTime : new Date();

        // 获取时间差（以毫秒为单位）
        var diff = end.getTime() - start.getTime();

        // 返回时间差（毫秒数）
        return diff;
    }
}

Workflow.createFun = function (fun, arg) {
    new Promise((resolve) => {
        var res = fun(arg);
        resolve(res);
    });
}

export default Workflow;


// const fun1 = (arg) => new Promise(resolve => {
// 	setTimeout(() => {
// 	    console.log("我运行了setTimeout,我是异步任务")
// 		resolve('test data ' + arg)
// 	}, 300)
// })

// var fun2=(p)=>{  return new Promise((resolve) => setTimeout(()=>{ console.log("我运行了Promise,我是异步任务"); resolve("Promise"); }, 1000)); }

// var fun3=()=>{ console.log("我运行了fun3,我是同步任务") }

// var tasts=[{fun:fun1,delay:200,params:1}, {fun:fun2,delay:100,params:2},{fun:fun1,delay:80,params:3},{fun:fun3,delay:40,params:3}]

// var ws=new Workflow(tasts);
// ws.runWorkflow()


